const i = () => /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
export {
  i as isMobileDevice
};
//# sourceMappingURL=userAgent.es.js.map
